import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.279 10.454 23 8.686a15.557 15.557 0 0 0-5.054-3.468A15.22 15.22 0 0 0 11.986 4a15.22 15.22 0 0 0-5.962 1.218A15.555 15.555 0 0 0 1 8.656s1.515 1.616 1.692 1.798C5.07 8.011 8.356 6.5 11.985 6.5c3.63 0 6.916 1.511 9.294 3.954Z" />
    <path d="M18.87 12.929C17.107 11.119 14.673 10 11.984 10c-2.688 0-5.122 1.12-6.884 2.929l1.721 1.768a7.184 7.184 0 0 1 5.163-2.197c2.017 0 3.842.84 5.163 2.197l1.721-1.768ZM14.739 17.172A3.831 3.831 0 0 0 11.985 16a3.831 3.831 0 0 0-2.753 1.172L11.985 20l2.754-2.828Z" />
  </svg>
);
export default IconWifiSizeM;
